/*
 * 注入配置向相关的变量
 */

export default function(injection, Vue) {
  const config = {
    apiUrl: {
      frontCol: '/api/blade-website/websitenews/front/col',
      search: '/api/blade-website/websitenews/front/search',
      frontList: '/api/blade-website/websitenews/front/list',
      detail: '/api/blade-website/websitenews/front/detail',
      member: '/api/blade-website/websitenews/front/member',
      jobList: '/api/blade-website/websitenews/front/zp'
    }
  };
  Object.defineProperties(Vue.prototype, {
    $config: {
      get() {
        return config;
      }
    }
  });

  Object.defineProperties(injection, {
    config: {
      get() {
        return config;
      }
    }
  });
}
